export const createConfigAction = (congifDetails)=>{
    return {type:'CREATE_NEW_CONFIG',payload:congifDetails}
}

export const createConfigData = (configData)=>{
    return {type:"SUCCESSFULL_CREATE_CONFIG",payload:configData}
}